import { Module, Mutation, Action } from "vuex-module-decorators";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest } from "@/utils/request";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { formatSimpleMonthDate } from "@/utils/common/date";
import type { PaginationDataState } from "@/types";
import { WarehouseRecordTypeEnums, ScanTypeEnums } from "@/enums/warehouse";
import { httpServer as http } from "@/http/tbrScanAxios";
export interface WarehouseHistoryState extends PaginationDataState {
  recordType: string;
  searchCondition: any;
}

const defaultSearchInstance = () => ({
  keyword: ""
});
@Module({ name: "WarehouseHistoryModule", namespaced: true })
export default class WarehouseHistoryModule
  extends PaginationModule<WarehouseHistoryState, RootState>
  implements WarehouseHistoryState {
  public listData: any[] = [];
  public recordType: string = ""; // 出入库类型
  public searchCondition: any = defaultSearchInstance(); // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public timeSumMap = {}; // 时间统计集合
  public filterData: any = []; // 筛选条件数据

  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }
  @Mutation
  setRecordTypeMutation(data: string) {
    this.recordType = data;
  }
  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = defaultSearchInstance();
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }
  @Mutation
  setTimeSumMapMutation({ key = "", value = "" } = {}) {
    if (!(key && value)) {
      this.timeSumMap = {};
    } else {
      this.timeSumMap[key] = value;
    }
  }

  @Action
  async queryListAction({ callback = data => data } = {}) {
    const {
      state: {
        recordType,
        paginationData,
        searchCondition,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;
    let tempParams;
    switch (recordType) {
      case WarehouseRecordTypeEnums.IN:
        tempParams = { scanType: "IN" };
        break;
      case WarehouseRecordTypeEnums.OUT:
        tempParams = { scanType: "OUT" }; //isWarrantyCard: "!3"
        break;
      case WarehouseRecordTypeEnums.BATCH_OUT:
        tempParams = {
          recordType: WarehouseRecordTypeEnums.OUT
          // isWarrantyCard: "3"
        };
        break;
    }
    const listRes = await http("/k2-scan/app/scan-record/queryPage", {
      ...tempParams,
      attribute: searchCondition.keyword || "",
      scanStartTime: searchCondition.startTime || "",
      scanEndTime: searchCondition.endTime || "",
      deductReturnToK1: true,
      pageNum,
      pageSize
    });
    let data = listRes?.data.list || [];
    // 对每个元素的 detailList 进行分组合并，按 specifications、pattern 和 level，quantity 字段相加
    data = data.map(item => {
      if (!item.detailList || !Array.isArray(item.detailList)) {
        return item;
      }
      const groupedMap = new Map();
      item.detailList.forEach(detail => {
        const key = `${detail.specifications || ""} ${detail.pattern || ""} ${
          detail.level || ""
        }`;

        if (groupedMap.has(key)) {
          groupedMap.get(key).quantity += detail.quantity || 0;
        } else {
          groupedMap.set(key, { ...detail, spe: key });
        }
      });
      return {
        ...item,
        detailList: Array.from(groupedMap.values())
      };
    });
    const totalCount = listRes?.data.total || 0;
    data = await callback(data);
    commit(
      pageNum === 1 ? "saveListDataMutation" : "addListDataMutation",
      data
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async queryFilterDataAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "BONUS_SOURCE", // 奖励金筛选
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("setFilterDataMutation", data);
  }

  @Action
  async queryListSumAction(params: any) {
    const {
      state: {
        recordType,
        paginationData,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;

    let tempParams;

    switch (recordType) {
      case WarehouseRecordTypeEnums.IN:
        tempParams = { scanType: ScanTypeEnums.IN };
        break;
      case WarehouseRecordTypeEnums.OUT:
        tempParams = { scanType: ScanTypeEnums.OUT }; //isWarrantyCard: "!3"
        break;
      case WarehouseRecordTypeEnums.BATCH_OUT:
        tempParams = {
          recordType: WarehouseRecordTypeEnums.OUT
        };
        break;
    }
    const { date } = params;
    const res = await http("/k2-scan/app/scan-record/queryK2AppScanByMonth", {
      ...tempParams,
      scanStartYearMonth: date[0].slice(0, 7),
      scanEndYearMonth: date[date.length - 1].slice(0, 7),
      deductReturnToK1: true
    });
    const list = res.data.list || {};
    list.forEach(o => {
      this.context.commit("setTimeSumMapMutation", {
        key: formatSimpleMonthDate(o.date),
        value: o
      });
    });
  }
}
